import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { SamlIdentityProvidersApi, UpdateSamlIdentityProviderDto } from '../../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { getApiConfiguration } from '../../../../common';

type UseUpdateSamlProvider = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    { id: string; updateIdentityProviderDto: UpdateSamlIdentityProviderDto }>,
    'mutationFn'>,
) => UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  { id: string; updateIdentityProviderDto: UpdateSamlIdentityProviderDto }
>;

export const useUpdateSamlProvider: UseUpdateSamlProvider = (
  options,
) => {
  const samlIdentityProviderApi = new SamlIdentityProvidersApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ id, updateIdentityProviderDto }) =>
      samlIdentityProviderApi.updateSamlProvider(id, tenantId, updateIdentityProviderDto),
    options,
  );
}
